export default function getProfileImage(fileName) {
  switch (fileName) {
    case 'pi-set-1-0':
      return '/images/profileImages/pi-set-1-0.png';
    case 'pi-set-1-1':
      return '/images/profileImages/pi-set-1-1.png';
    case 'pi-set-1-2':
      return '/images/profileImages/pi-set-1-2.png';
    case 'pi-set-1-3':
      return '/images/profileImages/pi-set-1-3.png';
    case 'pi-set-1-4':
      return '/images/profileImages/pi-set-1-4.png';
    case 'pi-set-1-5':
      return '/images/profileImages/pi-set-1-5.png';
    case 'pi-set-1-6':
      return '/images/profileImages/pi-set-1-6.png';
    case 'pi-set-1-7':
      return '/images/profileImages/pi-set-1-7.png';
    case 'pi-set-1-8':
      return '/images/profileImages/pi-set-1-8.png';
    case 'pi-set-1-9':
      return '/images/profileImages/pi-set-1-9.png';
    default:
      return '/images/profileImages/pi-set-1-0.png';
  }
}
